'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * # Modulo
 * Float safe modulo call. Based off just-modulo, but made float safe. Math with floats can have unexpected results in JS
 *
 * @param {Function} func
 * @param {Integer} delay
 *
 * @see http://www.codeavenger.com/2017/05/19/JavaScript-Modulo-operation-and-the-Caesar-Cipher.html
 * @see https://github.com/angus-c/just#just-modulo
 */

function modulo(val, step) {
  val = Number(val);
  step = Number(step);

  // step needs to be > 0
  if (step <= 0) {
    return NaN;
  }
  var valDecCount = (val.toString().split('.')[1] || '').length;
  var stepDecCount = (step.toString().split('.')[1] || '').length;
  var decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  var valInt = parseInt(val.toFixed(decCount).replace('.', ''));
  var stepInt = parseInt(step.toFixed(decCount).replace('.', ''));

  return (valInt % stepInt + stepInt) % stepInt / Math.pow(10, decCount);
}

exports.default = modulo;
module.exports = exports['default'];
//# sourceMappingURL=modulo.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/js/dist/helpers/util/modulo.js
// module id = 421
// module chunks = 0